export default (error) => {
    /* eslint no-console: "error" */
    if (error.response) {
        if (process.env.NODE_ENV === 'development') {
            /* eslint-disable no-console */
            console.error(error.response.data);
            console.error(error.response.status);
            console.error(error.response.headers);
        }
        if (error.response.data && error.response.data.errors) {
            return error.response.data.errors;
        }
        return 'API Error, please try again.';
    }

    if (process.env.NODE_ENV === 'development') {
        /* eslint-disable no-console */
        console.error(error);
    }

    return error;
};
